import {
  AddOnDemandPickupRequest,
  EditOnDemandPickupRequest,
} from 'src/app/core/models/operations/operations-on-demand-pickup.model';

export const CONSTANTS = {
  HEADER: $localize`OnDemand Pickup Details`,
  SCHEDULING_SUBHEADER: $localize`Scheduling`,
  SAVE: $localize`Save`,
  SCHEDULING: {
    REQUEST_NUMBER: $localize`Request/Shipper No.`,
    ORDER_TYPE: $localize`Order Type`,
    CSTC_SITE_NAME: $localize`CSTC Site Name`,
    READY_TIME: $localize`Ready Time`,
    ORDER_DATE: $localize`Order Date`,
    SERVICE_CENTER_SLIC: $localize`Service Center SLIC`,
    CSTC_OPERATOR: $localize`CSTC Operator`,
    SERVICE_DATE: $localize`Service Date`,
    PREFERRED_CUSTOMER: $localize`Preferred Customer`,
    CSTC_SITE_PHONE: $localize`CSTC Site Phone`,
    COMMIT_TIME: $localize`Commit Time`,
    SERVICE_TYPE: $localize`Service Type`,
    PACKAGE_TYPE: $localize`Package Type`,
    SHIP_CHARGE: $localize`Ship/PU Charge`,
    PICK_UP_AMT: $localize`Pick Up Amt`,
    CLOSING_TIME: $localize`Closing Time`,
    SHIPPER_NUMBER: $localize`Shipper Number`,
    PACKAGE_WEIGHT: $localize`Package Weight`,
    VAT_PORTION: $localize`Vat Portion`,
    PICKUP_NUMBER: $localize`Pickup Number`,
    OVER_WEIGHT: $localize`Over Weight`,
    DRIVER_INSTRUCTIONS: $localize`Driver Instructions`,
  },
  VALIDATE_MODAL: {
    HEADER: $localize`Validate`,
    BODY: $localize`Please validate before submit`,
    CONFIRM_BUTTON: $localize`Ok`,
  },
};

export const ACTIONS = {
  SCHEDULING: 'scheduling',
  CURRENT_PICKUP_ADDRESS: 'currentPickupAddress',
  ORIGINAL_ADDRESS: 'originalAddress',
  PARSED_ADDRESS: 'parsedAddress',
  NOTES: 'notes',
};

export const ON_DEMAND_PICKUP_CONTROLS = {
  READY_TIME: 'readyTime',
  COMMIT_TIME: 'commitTime',
  CLOSING_TIME: 'closingTime',
};

export const CURRENT_PICKUP_CONTROLS = {
  CUSTOMER_NAME: 'customerName',
  CONTACT_NAME: 'contactName',
  CONTACT: 'contact',
  STREET_ADDRESS: 'streetAddress',
  PREFIX: 'prefix',
  STREET_NAME: 'streetName',
  SUFFIX: 'suffix',
  STREET_TYPE: 'streetType',
  SUITE: 'suite',
  FLOOR: 'floor',
  CITY_TOWN: 'cityTown',
  PROVINCE: 'province',
  POSTAL_CODE: 'postalCode',
  LATITUDE: 'latitude',
  LONGITUDE: 'longitude',
};

export const NOTES_CONTROLS = {
  SSC_DESCRIPTION: 'sscDescription',
  ADDITIONAL_INFORMATION: 'additionalInformation',
  DRIVER_REPLY: 'driverReply',
};

export const SCHEDULED_PICKUPS = {
  READY_TIME: 'readyTime',
  COMMIT_TIME: 'commitTime',
  CLOSING_TIME: 'closingTime',
};

export const MOCK_EDIT_ON_DEMAND_PICKUP_REQUEST: EditOnDemandPickupRequest = {
  ondemandPickup: {
    orderNumber: '297AK841OCE',
    readyTime: '00:00',
    closingTime: '13:00',
    commitTime: '13:00',
    custName: 'IVA CANADA ACR 058 061 12',
    contName: 'NA NA',
    contact: '9055422422',
    suite: 'null',
    streetAddress: '22',
    prefix: 'null',
    streetName: 'QUEEN',
    streetType: 'ST',
    suffix: 'null',
    floor: 'null',
    cityTown: 'STANCHEL',
    province: 'PE',
    postalCode: 'C0A1Y0',
    latitude: 'null',
    longitude: 'null',
    addlinfo: 'null',
  },
};

export const MOCK_ON_DEMAND_PICKUP_REQUEST: AddOnDemandPickupRequest = {
  closingtime: '13:03',
  comments: '',
  commitTime: '13:00',
  contactName: 'Manager',
  customerName: 'TUNDRA USER',
  floor: '',
  route: '1',
  latitude: '',
  longitude: '',
  onDemand: 'true',
  orderType: '',
  phoneNumber: '1234567891',
  pickupPoint: 'Garage',
  politicalDivision1: 'PE',
  politicalDivision2: 'PE',
  postalCode: 'C1B2C2',
  readyTime: '13:00',
  room: '',
  shippingNumber: '063X69',
  sscCodes: '',
  startDate: '2024-01-16',
  streetName: 'WREN DR',
  streetAddress: '',
  streetPrefix: '',
  streetSuffix: '',
  streetType: '',
  prnNr: '123',
};
